module.exports = __webpack_public_path__ + "static/media/vu.80f0103b.svg";